import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-tips',
  templateUrl: './coachmark-tips.component.html',
  styleUrls: ['./coachmark-tips.component.scss']
})
export class CoachmarkTipsComponent implements OnInit {
  show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.moveMsg();
  }

  gotIt() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('tips', false));
  }


  moveMsg() {
   const waitRendering =  setInterval( () => {
      const elem = document.getElementsByClassName('buttonProfileHouse')[0];
      // console.log(elem);
        const elemPosition: ClientRect = elem.getBoundingClientRect();
          if ($('#coachmarkTips').length === 1) {
            $('#coachmarkTips').css('left', elemPosition.left - 75)
              .css('top', elemPosition.top + window.scrollY + 85)
              .css('display', 'block');
          }
          this.show = true;
          clearInterval(waitRendering);
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-tips/coachmark-tips.component.ts